import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-simple-tryb-pagination',
    templateUrl: './simple-tryb-pagination.component.html',
    styleUrls: ['./simple-tryb-pagination.component.scss'],
    standalone: false,
})
export class SimpleTrybPaginationComponent {
    @Input() collectionSize: number;
    @Input() page: number;
    @Input() pageSize: number;
    // Window size (example: 3=left+selected+right
    // (if left or right does not exist because selected
    // is boundary another item on the other side is added))
    @Input() maxSize: number;
    // Rotates pages such that the current page is always in the middle of the pagination (except boundaries)
    @Input() rotate = true;
    // Activates ... in pagination if maxsize+2< number of pages
    @Input() ellipses = true;
    // Activates arrow buttons for first and last page
    @Input() boundaryLinks = true;
    // Activates arrow buttons for next and previous page
    @Input() directionLinks = true;
    // Determines style of pagination ('sm' and 'lg' default styles of ng-bootstrap, 'tryb' is a custom style)
    @Input() style: 'sm' | 'lg' | 'tryb' = 'tryb';

    @Output() pageChange = new EventEmitter<number>();

    onPageChange(page: number) {
        this.pageChange.emit(page);
    }
}
